var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsalcoSymbolPurple200(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1603,
    height: 1484,
    viewBox: "0 0 1603 1484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M872.687 1481.07C1250.22 1447.15 1550.99 1136.81 1574.7 758.625C1592.1 481.125 1460.74 243.209 1299.15 18.7627C1291.11 7.46232 1277.85 0.716797 1263.93 0.716797H1002.09C984.259 0.716797 973.827 21.1486 984.476 35.2904C1006.23 64.4416 1028.62 93.3541 1050.8 122.072C1185.84 296.48 1325.68 476.983 1327.22 700.779C1328.95 970.449 1121.27 1202.29 852.906 1227.95C539.964 1257.97 275.5 1011.57 275.5 704.488C275.5 478.089 422.731 287.587 564.951 103.592C582.563 80.7523 599.959 58.1298 616.92 35.7459C627.57 21.3872 617.354 0.738475 599.308 0.738475H337.685C323.543 0.738475 310.29 7.48402 302.244 19.0013C149.59 233.839 26.0667 458.937 26.0667 709.021C26.0667 1160.06 413.382 1522.39 872.925 1481.07H872.708H872.687Z",
    fill: "#8A94F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1595.26 507.392C1596.28 511.665 1602.57 510.884 1602.57 506.481V43.7497C1602.57 20.0427 1583.22 0.695312 1559.3 0.695312H1381.4C1363.79 0.695312 1353.55 20.4765 1363.79 35.052C1466.95 182.955 1554.57 337.756 1595.28 507.392H1595.26Z",
    fill: "#8A94F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.711 0.695312H43.245C19.5597 0.695312 0.190674 20.0644 0.190674 43.7497V507.349C0.190674 511.73 6.45904 512.533 7.47847 508.26C48.1253 340.857 135.167 184.951 238.54 34.8352C248.54 20.4765 238.324 0.695312 220.711 0.695312Z",
    fill: "#8A94F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.66 148.598C983.826 105.978 950.553 62.9233 919.016 18.9797C910.752 7.46234 897.695 0.716797 883.575 0.716797H718.298C704.373 0.716797 691.555 7.46234 683.291 18.5459C656.547 55.3102 628.047 92.2697 598.917 129.902C445.158 328.884 285.542 535.285 324.237 778.623C358.594 994.568 536.494 1164.42 754.195 1185.09C1041.48 1212.29 1283.97 986.326 1283.97 704.466C1283.97 493.727 1148.04 318.235 1016.69 148.598H1016.66ZM735.043 901.713C681.1 884.969 636.745 844.734 613.688 793.416C534.303 617.468 712.637 487.199 782.674 360.638C790.938 345.846 812.259 345.412 820.306 360.421C882.512 474.597 1008.64 570.075 1008.64 704.683C1008.64 839.29 877.719 946.091 735.065 901.93V901.713H735.043Z",
    fill: "#8A94F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1602,
    height: 1483,
    fill: "white",
    transform: "translate(0.190674 0.807617)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsalcoSymbolPurple200);
export default __webpack_public_path__ + "static/media/usalco-symbol-purple200.4106819a41b4b8ae2f344a3d76d4326a.svg";
export { ForwardRef as ReactComponent };